import type { DanoVeicular } from './danoVeicular'

export type GrauEncarceramento = 'mecanico' | 'fisicoI' | 'fisicoII'
export type EstadoEncarceramento = 'avaliar' | 'possivel'

export interface LeituraEncarceramento {
  grau: GrauEncarceramento
  nome: string
  estado: EstadoEncarceramento
  leitura: string
}

export interface RetencaoEstrutural {
  membro: string
  leitura: string
}

/**
 * Mantém os três graus separados. Nenhum deles é inferido como diagnóstico:
 * dano visual não prova saída bloqueada e gravidade clínica não prova tipo I.
 */
export function classificarEncarceramentos(
  dano: DanoVeicular,
  retencoes: readonly RetencaoEstrutural[],
): LeituraEncarceramento[] {
  const deformacaoRelevante = dano.nivel === 'moderado' || dano.nivel === 'severo'
  return [
    {
      grau: 'mecanico',
      nome: 'Mecânico',
      estado: deformacaoRelevante ? 'possivel' : 'avaliar',
      leitura: deformacaoRelevante
        ? 'Há deformação relevante; confirme se portas ou outras saídas ficaram impedidas.'
        : 'Verifique se alguma deformação do veículo impede a saída da vítima.',
    },
    {
      grau: 'fisicoI',
      nome: 'Físico tipo I',
      estado: 'avaliar',
      leitura:
        'Depende da avaliação clínica: lesões podem impedir a vítima de sair sozinha. O estado “grave” isoladamente não confirma este grau.',
    },
    {
      grau: 'fisicoII',
      nome: 'Físico tipo II',
      estado: retencoes.length > 0 ? 'possivel' : 'avaliar',
      leitura:
        retencoes.length > 0
          ? `${retencoes.length} membro(s) mantido(s) em zona de retenção estrutural. Confirme aprisionamento ou penetração.`
          : 'Verifique se alguma parte do veículo prende ou penetra a vítima. Penetração não é simulada graficamente.',
    },
  ]
}
